import { Component, OnInit } from '@angular/core';
import { AuthService } from '@personal-area/global/authorization/services';

@Component({
  selector: 'retry',
  templateUrl: 'retry.component.html',
  styleUrls: ['retry.component.scss']
})

export class RetryComponent implements OnInit {

  constructor(
    private _authService: AuthService
  ) {
  }

  ngOnInit() {
  }

  public reload() {
    window.location.reload();
  }

  public get isLoggedIn() {
    return this._authService.isLoggedIn;
  }
}
